import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./district.scss";
import CommunicationDataGrid from "../../components/communicationdatagrid/CommunicationDataGrid";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import { Button } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { toast } from "sonner";

function District() {
  let { id } = useParams();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [followUpData, setFollowUpData] = useState([]);
  const getCommunicationData = async () => {
    axiosInstance
      .post("/getdistrictfollowup", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        dist_id: id,
      })
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setFollowUpData(res.data.data.district_followups);
      });
  };

  useEffect(() => {
    getCommunicationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="district">
      <Button
        variant="outlined"
        onClick={() => navigate(-1)}
        className="flex items-center pr-2 pl-1"
      >
        <ChevronLeft className="p-0 m-0" size={16} />
        Back
      </Button>
      {/* <h3 className="text-2xl m-3 font-sans font-light">Nabarangpur</h3> */}
      {/* <TopWidgets /> */}
      {/* <StackedAreaChart title="Usage Period" width="100%" height={300} /> */}
      {/* <TopSchoolsTable /> */}

      <CommunicationDataGrid data={followUpData} />
    </div>
  );
}

export default District;
